import useHeartRateEventBox from './useHeartRateEventBox';

export type HeartRateEventBoxProps = {
  activeButton: any;
  studyId: string;
  profileId: string;
  // wrapReport.tsx also passes this, but the component never reads it - pre-existing.
};

/**
 * Resolves the holter event behind a heart-rate event box on the ECG events tab. Renders an empty div when useHeartRateEventBox finds no matching event, and renders nothing at all once one is found.
 *
 * @param props - Event box inputs used by useHeartRateEventBox to look up the holter event.
 * @returns An empty div while no holter event resolves, otherwise nothing.
 */
const HeartRateEventBox = ({ activeButton, studyId, profileId }: HeartRateEventBoxProps) => {
  const { holterEvent } = useHeartRateEventBox({ activeButton, studyId, profileId });

  if (!holterEvent) {
    return <div />;
  }

  return null;
};

export default HeartRateEventBox;
